function TimePeriodsRepo({ GRAPHQL_URL, httpClient }) {
  this.getPeriodCardsForUser = ({ year }, { success, failure }) => {
    const query = `mutation ($year: Int!, $month: Int) {
                      getPeriodCardsForUser(actualsSearch: {year: $year, month: $month}) {
                        data {
                            usages  {
                              status
                              aws_product
                              elementMap {
                                element1Id
                                element2Id
                                element3Id
                                element4Id
                              }
                              accountId
                              percentage
                              breakdowns {
                                week
                                year
                                month
                                shared
                                claimed
                                dateRange
                                isCurrent
                              }
                            }
                            currentTimeRanges {
                               dateRange
                               week
                            }
                            previousTimeRanges {
                               dateRange
                               week
                            }
                        }
                        error {
                          code
                          message
                          statusCode
                        }
                      }
                    }`

    httpClient.request(
      {
        method: 'POST',
        url: GRAPHQL_URL,
        data: {
          query,
          variables: {
            year
          }
        }
      },
      {
        success: (response) => {
          const { getPeriodCardsForUser } = response.data.data
          success(getPeriodCardsForUser)
        },
        failure: (error) => failure(error)
      }
    )
  }
}

export default TimePeriodsRepo
